import React from "react";
import HomeTemplate from "./HomeTemplate";

export default function HomePage() {
  return <HomeTemplate />;
}
